import Upload from './upload';

export default Upload;
export { default as SingleFileUpload } from './single-file-upload';
